var version = {
    "name":      "dativery",
    "buildDateCode": "20260925-144727",
    "buildDate": "Fri Sep 25 2026 14:47:27 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260925-144727",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;